import React, { FC } from 'react';
import Icon from '@common/assets';
import { ProfileSkillDto } from '@domain/rs/phs/center/ProfileSkillDto';
import { SkillLevelNameMap } from '@domain/constant/profile/SkillType';
import classnames from 'classnames/bind';
import styles from './skillKeywordChipList.module.scss';

const cx = classnames.bind(styles);

interface SkillKeywordChipListProps {
  selectedSkills: ProfileSkillDto[];
  setSelectedSkills: React.Dispatch<React.SetStateAction<ProfileSkillDto[]>>;
}

const SkillKeywordChipList: FC<SkillKeywordChipListProps> = ({ selectedSkills, setSelectedSkills }) => {
  const skillKeywordChipsEl = selectedSkills.map((skill, idx) => {
    const handleDelete = () => setSelectedSkills((prev) => prev.filter((_, i) => i !== idx));

    return (
      <li key={idx} className={cx('listItem')}>
        {skill.keyword} - {SkillLevelNameMap[skill.level]}
        <a className={cx('btnDelete')} role="button" onClick={handleDelete}>
          <Icon name="closeLight" width={24} height={24} />
        </a>
      </li>
    );
  });

  return <ul className={cx('selectList')}>{skillKeywordChipsEl}</ul>;
};

export default SkillKeywordChipList;
